<template>
    <v-container grid-list-md class="form-user-payment">
        <v-layout row wrap>
            <v-flex md8>
                <v-form ref="form_user_profile">
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Nội dung chuyển khoản:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-card dark color="lime lighten-5" class="mb-5 text-center">
                                <v-card-text class="black--text text-center">
                                    <h2 >{{ contentTransfer }}</h2>
                                </v-card-text>

                                <v-btn color="black" class="white--text mb-5"  @click="copyContent">
                                    <v-icon left color="white">file_copy</v-icon>
                                    Copy
                                </v-btn><br>
                                <v-btn color="secondary" class="white--text mb-5" v-if="show">
                                    Đã copy !
                                </v-btn>


                            </v-card>
                            <input type="hidden" id="content-transfer" :value="contentTransfer"/>
                        </v-flex>
                    </v-layout>
                    <template v-for="(account, index) in bankAccounts">
                        <v-layout align-center row class="pa-0" v-bind:key="account.account_id">
                            <v-flex md4>
                                <label class="text-color">Tài khoản số: {{ index+1 }}</label>
                            </v-flex>
                            <v-flex md8>
                                <v-card dark color="lime lighten-5" class="">
                                    <v-card-text class="ml-5 black--text">
                                        <p class="info-account">
                                            Ngân hàng:<span class="font-weight-bold ml-9">{{ account.bank_name }}</span><br>
                                            Chủ tài khoản: <span class="font-weight-bold ml-3">{{ account.account_name }}</span><br>
                                            Số tài khoản: <span class="font-weight-bold ml-5">{{ account.account_id }}</span><br>
                                            Chi nhánh: <span class="font-weight-bold ml-9">{{ account.account_branch }}</span>
                                        </p>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </template>
                    <v-layout align-center row class="pa-0">
                        <v-flex md12>
                            <v-card color="" class="">
                                <v-card-text class="black--text pr-5">
                                    <p class="info-account">
                                        Tỷ giá: 1 VND = 1 {{ coin_name }} <br><br>
                                        Nạp tiền bằng hình thức chuyển khoản ngân hàng sẽ dc nạp sau 5 phút.<br>
                                        Nạp qua momo vui lòng đợi 1-2h <br>
                                        Bạn nên chọn chuyển tiền nhanh 24/7  trong trường hợp chuyển khoản từ NGÂN HÀNG khác thì mới nhận đc tiền luôn ko thì phải mất 1 ngày NGÂN HÀNG mới duyệt tiền. <br>
                                        Chú ý: Nạp sai cú pháp sẽ bị trừ 10% tiền nạp!. <br>
                                    </p>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>


                </v-form>
            </v-flex>
            <v-flex md4>
                <UserPaymentRight :balanceCurrent="balanceCurrent" :balanceWithdraw="balanceWithdraw" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import UserPaymentRight from "~/components/user-payment/UserPaymentRight";
    import { COLOR } from "~/config/constant";

    import {AUTH_GET_INFO_RECHARGE} from "~/store/actions.type";
    import {CONFIG_PAGE} from "../../store/actions.type";

    export default {
        name: "UserPaymentSetting",
        components: {
            UserPaymentRight
        },
        data() {
            return {
                // Color chinh
                COLOR: COLOR,

                bankAccounts: [],

                // Noi dung chuyen khoan
                contentTransfer: "",

                balanceCurrent: 0,
                balanceWithdraw: 0,

                show: false,

                coin_name: 'coin',

            }
        },

        created() {

        },

        computed: {

        },
        mounted() {
            this.getDataFromApi();
            this.configPage();
        },
        watch: {

        },
        methods: {
            async getDataFromApi () {

                let data = await this.$store.dispatch(AUTH_GET_INFO_RECHARGE);
                this.bankAccounts = data.bank_accounts;

                this.contentTransfer = data.content;
                this.balanceCurrent = parseInt(data.coin);
                this.balanceWithdraw = parseInt(data.money_recharged);
            },

            copyContent() {
                let testingCodeToCopy = document.querySelector('#content-transfer')
                testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
                testingCodeToCopy.select()

                try {
                   document.execCommand('copy');
                } catch (err) {
                    alert('Oops, unable to copy');
                }

                /* unselect the range */
                testingCodeToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()

                this.show = true;
                let aThis = this;
                setTimeout(function () {
                    aThis.show = false;
                }, 2000);
            },

            async configPage(){
                await this.$store.dispatch(CONFIG_PAGE).then((data) => {
                    let coin_name = data.filter(o => o.key == 'key_cp_content_coin_name');
                    if(coin_name[0]['value'] != undefined && coin_name[0]['value'] != '' && coin_name[0]['status']){
                        this.coin_name = coin_name[0]['value'];
                    }

                    let bank_accounts = data.filter(o => o.key == 'key_cp_bank_accounts');
                    if(bank_accounts[0]['value'] != undefined && bank_accounts[0]['value'] != '' && bank_accounts[0]['status']){
                        this.bank_accounts = bank_accounts[0]['value'];
                    }
                });
            },

        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";
    .form-user-payment {
        background-color: $bgMainColor;
        max-width: 100% !important;

        /*.v-text-field__details{*/
        /*    !*display: none;*!*/
        /*}*/
        .text-color{
            color: $mainColor;
            font-weight: bold;
        }
        .info-account {
            font-size: 16px;
            padding-right: 7px;
            text-align: justify;
            text-justify: inter-word;
        }
    }
</style>
